{
  "clear": "Ryd",
  "invalid": "(ugyldig)",
  "loading": "Indlæser...",
  "noResults": "Ingen resultater"
}
